'use strict';

import React from 'react';

// Rend un texte markdown léger (résumés IA des transcriptions SAV) :
// **gras**, *italique*, listes numérotées / à puces, retours à la ligne.
// Tout est construit en éléments React, sans dangerouslySetInnerHTML.

const formatInline = (text) => {
    const parts = text.split(/(\*\*[^*]+\*\*|\*[^*\n]+\*)/g).filter(Boolean);
    return parts.map((part, i) => {
        if (part.startsWith('**') && part.endsWith('**')) {
            return <strong key={i}>{part.slice(2, -2)}</strong>;
        }
        if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
            return <em key={i}>{part.slice(1, -1)}</em>;
        }
        return part;
    });
};

const RichText = ({ text }) => {
    if (!text) return null;
    let normalized = String(text);
    // Les résumés IA arrivent parfois sur une seule ligne : on recrée un
    // retour à la ligne devant chaque numéro de liste suivi de gras.
    if (normalized.includes('**')) {
        normalized = normalized.replace(/\s(\d+\.\s+\*\*)/g, '\n$1');
    }

    const blocks = [];
    let list = null;
    const flushList = () => {
        if (list) {
            blocks.push(list);
            list = null;
        }
    };

    normalized.split('\n').forEach((raw) => {
        const line = raw.trim();
        if (!line) {
            return; // une ligne vide ne coupe pas une liste (items markdown souvent espacés)
        }
        const ordered = line.match(/^(\d+)[.)]\s+(.*)/);
        const bullet = line.match(/^[-•*]\s+(.*)/);
        if (ordered || bullet) {
            const isOrdered = Boolean(ordered);
            if (!list || list.ordered !== isOrdered) {
                flushList();
                list = { ordered: isOrdered, items: [] };
            }
            list.items.push(ordered
                ? { num: parseInt(ordered[1], 10), text: ordered[2] }
                : { text: bullet[1] });
        } else {
            flushList();
            blocks.push({ paragraph: line });
        }
    });
    flushList();

    return (
        <div style={{ textAlign: 'left' }}>
            {blocks.map((block, i) => {
                if (block.paragraph !== undefined) {
                    return (
                        <p key={i} style={{ margin: '0 0 8px' }}>
                            {formatInline(block.paragraph)}
                        </p>
                    );
                }
                const ListTag = block.ordered ? 'ol' : 'ul';
                return (
                    <ListTag key={i} style={{ margin: '0 0 8px', paddingLeft: 20 }}>
                        {block.items.map((item, j) => (
                            <li key={j} value={item.num} style={{ marginBottom: 4 }}>{formatInline(item.text)}</li>
                        ))}
                    </ListTag>
                );
            })}
        </div>
    );
};

export default RichText;
